import ErrorModal from 'Components/ErrorModal'
import React, { createContext, useState, useContext } from 'react'

export interface AppErrorInterface {
    title?: string
    message: string
    detail?: string
}

interface ErrorModalContextType {
    showError: (error: AppErrorInterface) => void
}

const ErrorModalContext = createContext<ErrorModalContextType | null>(null)

export const useErrorModal = () => {
    const ctx = useContext(ErrorModalContext)
    if (!ctx) {
        throw new Error('useErrorModal debe usarse dentro de ErrorModalProvider')
    }
    return ctx
}

export const ErrorModalProvider: React.FC = ({ children }) => {
    const [error, setError] = useState<AppErrorInterface | null>(null)

    const showError = (err: AppErrorInterface) => {
        setError(err)
    }

    const handleClose = () => setError(null)

    return (
        <ErrorModalContext.Provider value={{ showError }}>
            {children}
            <ErrorModal error={error} onClose={handleClose} />
        </ErrorModalContext.Provider>
    )
}
